var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrCardBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 205,
    viewBox: "0 0 262 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395 133.5C395 207.23 335.23 267 261.5 267C187.77 267 128 207.23 128 133.5C128 59.77 187.77 0 261.5 0C335.23 0 395 59.77 395 133.5Z",
    fill: "#D0FFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262 236C262 308.349 203.349 367 131 367C58.6507 367 0 308.349 0 236C0 163.651 58.6507 105 131 105C203.349 105 262 163.651 262 236Z",
    fill: "#A7FFAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262 236C262 308.349 203.349 367 131 367C58.6507 367 0 308.349 0 236C0 163.651 58.6507 105 131 105C203.349 105 262 163.651 262 236Z",
    fill: "#A7FFAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262 236C262 308.349 203.349 367 131 367C58.6507 367 0 308.349 0 236C0 163.651 58.6507 105 131 105C203.349 105 262 163.651 262 236Z",
    fill: "#A7FFAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262 236C262 308.349 203.349 367 131 367C58.6507 367 0 308.349 0 236C0 163.651 58.6507 105 131 105C203.349 105 262 163.651 262 236Z",
    fill: "#A7FFAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262 236C262 308.349 203.349 367 131 367C58.6507 367 0 308.349 0 236C0 163.651 58.6507 105 131 105C203.349 105 262 163.651 262 236Z",
    fill: "#A7FFAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrCardBg);
export default __webpack_public_path__ + "static/media/br-card-bg.a790a019a3cf26f54b086db9b882b094.svg";
export { ForwardRef as ReactComponent };